import { createFileRoute } from "@tanstack/react-router";
import { fetchSubscriptions } from "@/features/notifications/queries";
import { queryKeys } from "@/lib/query-keys";
import { NotificationsSettingsPage } from "@/features/notifications/pages/notifications-settings-page";

export const Route = createFileRoute("/_authed/tenants/$slug/settings/notifications")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.notifications.subscriptions(context.tenant.id),
      queryFn: () => fetchSubscriptions(context.tenant.id),
    }),
  component: NotificationsSettingsPage,
});
